import type { ThresholdSimulatorInstance } from './types';

export interface ThresholdSimulatorState {
  [thresholdPublicId: string]: ThresholdSimulatorInstance;
}

// NOTE:  This object is initially empty, and keyed by threshold.publicId
//        Data gets populated as users attempt to run TSim
export const initialState: ThresholdSimulatorState = {};
